import { render, staticRenderFns } from "./addOrgaManager.vue?vue&type=template&id=742550fa&scoped=true"
import script from "./addOrgaManager.vue?vue&type=script&lang=js"
export * from "./addOrgaManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742550fa",
  null
  
)

export default component.exports